<template>
  <el-dialog
    title="不可租标签"
    :visible.sync="show"
    width="50%"
    :before-close="closeModal"
  >
    <div>
      <el-form>
        <el-form-item label="不可租标签" label-width="100px">
          <el-checkbox-group v-model="checked">
            <el-checkbox
              v-for="(item, index) in allNonRentTagList"
              :label="item.id"
              :key="index"
            >
            {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getNonRentableList } from '@/api/domain/organize'
import { editTag } from '@/api/domain/cars'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  name: 'NonRentableTag',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentId: {
      type: [String, Number],
      default: '',
    },
    checkedList: {
      type: Array,
      default: () => [],
    },
    searchHandle: Function,
  },
  data() {
    return {
      allNonRentTagList: [],
      show: this.dialogVisible,
      checked: this.checkedList,
    }
  },
  watch: {
    checkedList: {
      handler(val) {
        this.checked = val
      },
      deep: true,
    },
    dialogVisible(val) {
      this.show = val
      val && this.handleTenantCustomTagList()
    },
  },
  methods: {
    // 获取车辆不可租标签
    async handleTenantCustomTagList() {
      const { code, data } = await getNonRentableList({ type: 1 })
      if (code !== 1) return
      this.allNonRentTagList = data.nonRentableTagList || []
    },
    // 提交已选标签
    async handleSubmit() {
      const params = {
        id: this.currentId,
        nonRentableTagList: this.checked,
      }
      const { code } = await editTag(params)
      this.closeModal()
      if (code !== 1) return
      this.$message.success('编辑成功')
      // 更新父组件的列表数据
      this.searchHandle && this.searchHandle()
      this.sendMessage()
    },
    closeModal() {
      this.show = false
      this.$emit('update:dialogVisible', false)
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
}
</script>
